import React from "react";
import { useEffect, useMemo } from "react";
import "../utils/default.css";
import Backend from "../utils/api.js";
import useTabs from "../utils/useTabs.jsx";

import SliderDisplay from "./Components/SliderDisplay/SliderDisplay.jsx";
import SliderMenu from "./Components/SliderMenu/SliderMenu";
import Slider from "./Components/Slider/Slider";
import DataTable from "./Components/DataTable/DataTable";
import { withRouter, useLocation } from "react-router-dom";

function TopUsers() {
  const [tabState, pushTab, revert] = useTabs();
  let location = useLocation();

  const tabs = useMemo(
    () => [
      (
        newProps //0
      ) => (
        <Slider
          name="Top tool instance users"
          navColor="rgb(255, 238, 83)" //TODO change
        >
          <SliderMenu
            placeholderText="Select a tool instance..."
            dataFunction={() =>
              Backend.getMachineByLab(
                location.state.userId,
                location.state.labId
              )
            }
            onClick={(e) =>
              pushTab(
                tabs[1]({ ...newProps, labId: e.labId, machineName: e.name })
              )
            }
          />
        </Slider>
      ),
      (
        newProps //1
      ) => (
        <Slider name="Top Users" navColor="rgb(226, 150, 90)">
          <DataTable
            title="Top tool instance users"
            columns={[
              { title: "User Name", field: "topuser" },
              { title: "Tool usage records", field: "requestsmade" },
            ]}
            dataFunction={() =>
              getTopUsers(
                location.state.userId,
                newProps.labId,
                newProps.machineName
              )
            }
          ></DataTable>
        </Slider>
      ),
    ],
    [location.state.userId, pushTab, revert]
  );

  useEffect(
    () => pushTab(tabs[0]({ userId: location.state.userId })),
    [location.state.userId, tabs, pushTab]
  );

  return <SliderDisplay>{tabState.tabs}</SliderDisplay>;
}

function getTopUsers(UID, labId, machineName) {
  machineName = machineName.toLowerCase();
  let map = new Map();
  return Backend.getRequestsByLab(UID, labId).then((response) => {
    if (response.status !== 200) {
      // Surface the real failure instead of masquerading as an empty-but-successful
      // result -- DataTable alerts on a non-200 status.
      return { items: [], status: response.status };
    }

    const items = response.data || response.items || [];
    items.forEach((request) => {
      // VS23: V2 reservations now come back enriched with tool_instances
      // (name-and-id pairs, since a reservation can span multiple tools)
      // and first_name/last_name, instead of V1's single `machine`/
      // `firstname`/`lastname` fields this used to look for.
      let requestMachineNames = (request.tool_instances || []).map((t) => (t.name || '').toLowerCase());
      let userName = `${request.first_name || request.user_id || ''} ${request.last_name || ''}`.trim();

      if (requestMachineNames.includes(machineName)) {
        if (map.has(userName)) {
          map.set(userName, map.get(userName) + 1);
        } else {
          map.set(userName, 1);
        }
      }
    });

    let toReturn = Array.from(map, ([topuser, requestsmade]) => ({
      topuser,
      requestsmade,
    }));
    toReturn.sort((a, b) => (a.requestsmade < b.requestsmade ? 1 : -1));
    return { items: toReturn, status: 200 };
  });
}

export default withRouter(TopUsers);
